import { Component, OnInit, ViewChild } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ISurveyors } from "app/models/core/admin/surveyors";
import { AdminService } from "app/services/admin/admin.service";
import { SharedService } from "app/services/core/shared.service";


@Component({
  selector: 'app-surveyors',
  templateUrl: './surveyors.component.html'

})

export class SurveyorsComponent implements OnInit {

  list: ISurveyors[] = [];
  item: ISurveyors;
  displayedColumns: string[] = ['t_CD', 'specialty', 'subSpecialty', 'pt', 'action'];

  dataSource = new MatTableDataSource<ISurveyors>(this.list);

  listFilter = '';
  editMode = 'list';

  formGroup = new UntypedFormGroup({
    SurveyorId: new UntypedFormControl(0),
    Initials: new UntypedFormControl('', [Validators.required, Validators.maxLength(10)]),
    Fullname: new UntypedFormControl('', [Validators.required, Validators.maxLength(100)]),
    Datecreated: new UntypedFormControl(''),
    CreatedBy: new UntypedFormControl(''),
    Lastupdated: new UntypedFormControl(''),
    UpdatedBy: new UntypedFormControl('')
  });

  @ViewChild('TablePaginator') paginator !: MatPaginator;
  @ViewChild('TableSort') sort!: MatSort;

  constructor(public adminService: AdminService,
    public sharedService: SharedService
  ) { };

  ngOnInit() {
    this.editMode = 'list';
    this.loadList();
  }

  loadList() {
    this.adminService.getSurveyors().subscribe(
      res => {
        this.list = res;
        this.dataSource.data = this.list;
        this.timeout();
      },
      error => console.log('error: ', error),
      () => {
        this.editMode = 'list';
      }
    );
  }

  timeout() {
    setTimeout(() => {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }, 500);
  }

  filterTable(evnt: Event) {
    this.listFilter = (evnt.target as HTMLInputElement).value;
    this.dataSource.filter = this.listFilter.trim().toLowerCase();
  }

  clearFilter() {
    this.listFilter = "";
    this.dataSource.filter = this.listFilter;
  }

  getPageSizeOptions(): number[] {
    if (this.dataSource.data.length > 20) {
      return [10, 20, this.dataSource.data.length];
    } else {
      return [10, 20];
    }
  }

  edit(item: ISurveyors) {
    this.item = item;
    this.formGroup.patchValue({
      SurveyorId: item.surveyorId,
      Initials: item.initials,
      Fullname: item.fullname,
      Datecreated: item.datecreated,
      CreatedBy: item.createdBy,
      Lastupdated: item.lastupdated,
      UpdatedBy: item.updatedBy
    });
    this.formGroup.markAsPristine();
    this.editMode = 'edit';
  }

  print() {
    //TODO
  }

  add() {
    this.clearForm();
    this.editMode = 'add';
  }

  clearForm() {
    this.formGroup.patchValue({
      SurveyorId: 0,
      Initials: '',
      Fullname: '',
      Datecreated: '',
      CreatedBy: '',
      Lastupdated: '',
      UpdatedBy: ''
    }
    );
  }

  save() {
    if (this.formGroup.valid && this.formGroup.dirty) {
      let form = this.formGroup.getRawValue();

      // Checking for duplicate codes
      let duplicate = false
      if (this.editMode == 'add') {
        let newCode = form.Initials;
        this.list.forEach(function (val) {
          if (val.initials == newCode) {
            alert('Duplicate Specialty ID. Please edit existing record.');
            duplicate = true;
          }
        });
      }

      if (!duplicate) {
        let evaluator: ISurveyors = {
          surveyorId: this.item.surveyorId,
          initials: this.item.initials,
          fullname: form.Fullname,
          datecreated: this.item.datecreated,
          createdBy: this.item.createdBy,
          lastupdated: this.item.lastupdated,
          updatedBy: this.item.updatedBy
        };

        this.adminService.saveSurveyors(evaluator, 'Save').subscribe(
          () => {
            this.loadList();
          },
          error => console.log('error: ', error),
          () => {
          }
        );
      }
    }
  }

  delete() {
    if (!confirm('DELETE Surveyor? Continue?')) {
      return;
    }
    this.adminService.saveSurveyors(this.item, 'Delete').subscribe(
      () => {
        this.loadList();
      },
      error => console.log('error: ', error),
      () => {
      }
    );
  }

  cancel() {
    if (this.formGroup.dirty) {
      if (!confirm('Unsaved changes. Continue?')) {
        return;
      }
    }
    this.clearForm();
    this.editMode = 'list';
  }

}